module.exports = __webpack_public_path__ + "static/media/iso9001.acdce4aa.svg";